import type { RecommendationsResponseBody } from '@noths/polaris-client-listings-api';
import type { ProductCarouselProduct } from '@noths/polaris-client-ribbons-design-system';

type ListingsAPIRecommendedProduct = RecommendationsResponseBody['products'][0];

export type ListingsCarouselProduct = ProductCarouselProduct &
  Pick<ListingsAPIRecommendedProduct, 'prices' | 'partner' | 'code'>;

interface AdaptedData {
  products: ListingsCarouselProduct[];
}

export const mapListingsProductToCarouselProduct = (
  product: RecommendationsResponseBody['products'][0],
): ListingsCarouselProduct => {
  const {
    code,
    freeDomesticDelivery,
    images,
    isNew,
    links,
    onSale,
    partner,
    preSalePrices,
    price,
    prices,
    purchasable,
    salePercentage,
    title,
  } = product;
  const { currency } = price;
  const preSalePrice = preSalePrices?.find((price) => price.currency === currency)?.amount;

  return {
    alt: '',
    code,
    freeDomesticDelivery,
    href: links[0]?.href || '',
    isNew,
    isPurchasable: purchasable,
    onSale,
    partner,
    preSalePrice,
    price: price.amount,
    prices,
    salePercentage,
    src: images[0]?.href || '',
    title,
  };
};

export const listingsAPIToProductCarouselAdapter = (
  data: RecommendationsResponseBody,
): AdaptedData => {
  const products = data.products.map(mapListingsProductToCarouselProduct);
  return {
    products,
  };
};
